import React from 'react';

export class SvgBackground extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
        <defs>
          <style>
            .cls-1<fill>#0b6574</fill>.cls-2<fill>#dd6c62</fill>
          </style>
        </defs>
        <title>tap-screen</title>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <rect fill="#0b6574" className="cls-1" width="300" height="300" />
            <polygon
              fill="#dd6c62"
              className="cls-2"
              points="55 89 45 89 45 45 89 45 89 55 55 55 55 89"
            />
            <polygon
              fill="#dd6c62"
              className="cls-2"
              points="255 89 245 89 245 55 211 55 211 45 255 45 255 89"
            />
            <polygon
              fill="#dd6c62"
              className="cls-2"
              points="255 255 211 255 211 245 245 245 245 211 255 211 255 255"
            />
            <polygon
              fill="#dd6c62"
              className="cls-2"
              points="89 255 45 255 45 211 55 211 55 245 89 245 89 255"
            />
          </g>
        </g>
      </svg>
    );
  }
}
